export const clearSessionPreservingConfigs = () => {
    const configs = sessionStorage.getItem('configs');
    sessionStorage.clear();
    if (configs) {
        sessionStorage.setItem('configs', configs);
    }
};
